// shallow equality for number[] to avoid redundant state updates
export const sameArray = (a: number[], b: number[]) => a.length === b.length && a.every((v, i) => v === b[i]);
